module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAMAAACelLz8AAAAWlBMVEUAAAAuLzZhqEIuLzZhqEJhqEJhqEIuLzYuLzYuLzZhqEJhqEJhqEJhqEJhqEIuLzZhqEIuLzYuLzYuLzYuLzZhqEIuLzYuLzZhqEIuLzZhqEJhqEIuLzZhqEKMdisFAAAAHHRSTlMA7kCR379/OgaIcM+fYFAO7+XXxKCPdE8wLCAQRM/mxgAAAJFJREFUKM+t0UkOwyAQRNGiDdiO7Tjz2HX/awYpSEjQySLKX7B5Eosu/NjQOW1y3ZCoU7MxkdMeTb06AKowUi20jZv8NiSkAJ4G4cwZCycY9PR8eN4sgtAzwiK+s0hk5iRiUQieuxAsAiIT2CRxaalU6Mt5yyhYR1ePkqe87uspc5o6Vh8XusBOD3d86LTiT70Ak3kTRgd0hSAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/zjzc_green.png
// module id = X7q3
// module chunks = 101